import Button from "@mui/material/Button";
import PropTypes from "prop-types";
// import { useWindowSize } from "@uidotdev/usehooks";

export const PremiseButton = ({ title, style }) => {
  // const { width } = useWindowSize();
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: "20px",
        padding: "3px 11px",
        color: "#151686",
        width: "257px",
        height: "auto",
        fontSize: "14px",
        fontWeight: "bold",
        textTransform: "none",
        fontFamily: " Montserrat",
        background: "linear-gradient(180deg, #FFF 0%, var(--NN-TM, #EFF0FF) 100%)",
        border: "1px solid var(--Background, #F1F6FA)",
        ...style,
      }}
    >
      {title}
    </Button>
  );
};
PremiseButton.propTypes = {
  title: PropTypes.string,
  style: PropTypes.object,
};
